import { variants } from './variants';

export const MuiTypographyTheme = {
  variants,
};
